import { IField, IHierarchyAPIQuery, HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import {
  HierarchyEntityName, deleteHierarchyEntityAPICallAction, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction, putHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<IField>(HierarchyLevelType.Field);

export const {
  itemsRequested: fieldsRequested,
  itemsRecieved: fieldsRecieved,
  itemsFailed: fieldsFailed,
  itemRecieved: fieldRecieved,
  itemDeleteRecieved: fieldsDeleteRecieved,
} = slice.actions;

export default slice.reducer;

export const getFields = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.FIELD, params, fieldsRequested.type, fieldsFailed.type, fieldsRecieved.type);

export const getField = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.FIELD, { entityId, parentId }, fieldsRequested.type, fieldsFailed.type, fieldRecieved.type);

export const createField = (data: Partial<IField>) => postHierarchyEntityAPICallAction(HierarchyEntityName.FIELD, data, fieldsRequested.type, fieldsFailed.type, fieldRecieved.type);

export const updateField = (data: Partial<IField>) => putHierarchyEntityAPICallAction(HierarchyEntityName.FIELD, data.fieldid!, data, fieldsRequested.type, fieldsFailed.type, fieldRecieved.type);

export const deleteField = (data: Partial<IField>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.FIELD, data.fieldid!, fieldsRequested.type, fieldsFailed.type, fieldsDeleteRecieved.type);
